export default function({ cursorNormal = 'pointer' } = {}) {
    return {
        data() {
            return {
                drag: false,
            };
        },
        computed: {
            cursor() {
                return this.drag ? 'grabbing' : cursorNormal;
            },
        },
        methods: {
            setDrag(value) {
                this.drag = value;
            },
        },
    };
}
